import { z } from 'zod'
import { ConfirmPasswordRequestSchema } from '~/services/api/generated'
import type { NoContext } from '~/services/api/contracts/NoContext'
import { fieldNormalizer } from '~/services/api/contracts/fieldNormalizer'

const normalize = fieldNormalizer({ always: { textOrEmpty: ['password'] } })

export const PasswordConfirmationStore = (_context: NoContext) =>
  z.preprocess(normalize, ConfirmPasswordRequestSchema.strict())
